
import BranchList from '../pages/BranchList';
import BranchShow from '../pages/BranchShow';
import Cart from '../pages/Cart';
import Address from "../pages/Address";
import NotFoundPage from '../pages/404.jsx';
import LoginSingUp from "../pages/LoginSingUp";
import Login from "../pages/Login";
import SingUp from "../pages/SingUp";
import MobileAuthentication from "../pages/MobileAuthentication";
import Payment from "../pages/Payment";
import Invoice from "../pages/Invoice";
import Tracking from "../pages/Tracking";
import OrdersList from "../pages/OrdersList";
import Contact from "../pages/Contact";
import Profile from "../pages/Profile";
import OrderDetails from "../pages/OrderDetails";
import MyAddress from "../pages/MyAddress";
import Events from "../pages/Events";
import City from "../pages/City";

let routes = [
    {
        path: '/',
        history: true,
        pushState: true,
        component: BranchList,
    },
    {
        path: '/branch/:branchId/',
        history: true,
        pushState: true,
        component: BranchShow,
    },
    {
        path: '/cart/',
        history: true,
        pushState: true,
        component: Cart,
    },
    {
        path: '/events/',
        history: true,
        pushState: true,
        component: Events,
    },
    {
        path: '/address/',
        history: true,
        pushState: true,
        component: Address,
    },
    {
        path: '/my-address/',
        history: true,
        pushState: true,
        component: MyAddress,
    },
    {
        path: '/login-singup/',
        history: true,
        pushState: true,
        component: LoginSingUp,
    },
    {
        path: '/login/',
        history: true,
        pushState: true,
        component: Login,
    },
    {
        path: '/signup/',
        history: true,
        pushState: true,
        component: SingUp,
    },
    {
        path: '/mobile-authentication/',
        history: true,
        pushState: true,
        component: MobileAuthentication,
    },
    {
        path: '/payment/',
        history: true,
        pushState: true,
        component: Payment,
    },
    {
        path: '/invoice/',
        history: true,
        pushState: true,
        component: Invoice,
    },
    {
        path: '/tracking/:orderId/',
        history: true,
        pushState: true,
        component: Tracking,
    },
    {
        path: '/order/:orderId/',
        history: true,
        pushState: true,
        component: OrderDetails,
    },
    {
        path: '/orders-list/',
        history: true,
        pushState: true,
        component: OrdersList,
    },
    {
        path: '/contact/',
        history: true,
        pushState: true,
        component: Contact,
    },
    {
        path: '/profile/',
        history: true,
        pushState: true,
        component: Profile,
    },
    {
        path: '/city/',
        history: true,
        pushState: true,
        component: City,
    },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
